export default {
  integratedHealthProfile: {
    id: 'integratedHealthProfile',
    label: 'Integrerad hälsoprofil',
    color: 'black',
    description:
      'Hälsoprofilsfrågor har integrerats i guiden. Om patienten har en separat hälsoprofil sedan tidigare har denna inte uppdaterats inför detta besök.',
  },
};
